module.exports = __webpack_public_path__ + "img/smartphone.5838c3b8.svg";